import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { FilterBarComponent } from "../filter-bar.component";
import { FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./group-button-filter.component.scss";

@Component({
    selector: "group-button-filter",
    template: require("./group-button-filter.component.html")
})
export class GroupButtonFilterComponent implements IFilterBarFilter<IGroupWithIds>, AfterViewInit {

    @Input() selected: IGroupWithIds;
    @Input() label: string;

    @Output() change = new EventEmitter<IGroupWithIds>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;

    // ---

    name = "Group";
    icon = "fa-solid fa-duotone fa-folder";
    type: FilterTriggerType = "group";

    searchString: string;

    private defaultLabel = "Any Group";

    constructor(private readonly parent: FilterBarComponent, readonly elementRef: ElementRef<HTMLElement>) {
        this.updateLabelText();
    }

    ngAfterViewInit(): void {
        this.parent.registerFilter(this);
    }

    onGroupSelected(group: IGroupWithIds): void {

        this.selected = group;
        this.updateLabelText();

        this.change.emit(group);
        this.parent.onFilterChange("group", group);
        this.parent.onFilterChange("custom", group, { customName: this.label, filterData: true });

        this.dropdown.closeDropdown();
    }

    clearSelectedVehicle(): void {
        this.onGroupSelected(null);
    }

    onDropdownClose(): void {
        this.parent.childClosed(this);
    }

    onSearch(text: string): void {
        this.searchString = text;
    }

    filterPredicate(item: any, value?: IGroupWithIds): boolean {

        if (item.VehicleId) {
            return value.VehicleIds.includes(item.VehicleId);
        }

        if (item.vehicle) {
            return value.VehicleIds.includes(item.vehicle.Id);
        }

        if (item.Vehicle) {
            return value.VehicleIds.includes(item.Vehicle.Id);
        }

        if (item.ShortReg) {
            return value.VehicleIds.includes(item.Id);
        }

        // Dont know how to cope with this
        return false;
    }

    // ---

    private updateLabelText(): void {
        if (this.selected) {
            this.label = this.selected.Name;
        }
        else {
            this.label = this.defaultLabel;
        }
    }
}
